<app-form-wizard *ngIf="isWizardVisible()" [formValues]="formValues" [template]="loginFormWizard" (actionButtonClick)="formWizardActionHandler($event)">
</app-form-wizard>
<div *ngIf="loginFailed" class="red mt-2 text-center">{{errorMessage}}</div>